module.exports = __webpack_public_path__ + "static/media/img-std.c537267f.png";